module.exports = __webpack_public_path__ + "static/img/pic-02.669412a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-02.png
// module id = Z3oC
// module chunks = 1